/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */

import React from 'react';
import { useIntl } from 'react-intl';
import {
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  makeStyles,
  Typography
} from '@material-ui/core';

const useStyles = makeStyles({
  dialog: {
    fontWeight: 'bold'
  },
  button: {
    minWidth: '100px'
  }
});

export default function Dialog({ visible, text, okHandler, yesHandler, noHandler, cancelHandler, close }) {
  const { formatMessage } = useIntl();
  const classes = useStyles();

  return (
    <MuiDialog
      open={!!visible}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Typography variant="h6" className={classes.dialog}>
          {formatMessage({ id: 'general.confirmation' })}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {!!yesHandler && (
          <Button classes={{ root: classes.button }} variant="contained" onClick={yesHandler} color="primary">
            {formatMessage({ id: 'form.yes' })}
          </Button>
        )}
        {!!noHandler && (
          <Button classes={{ root: classes.button }} variant="outlined" onClick={noHandler} color="primary">
            {formatMessage({ id: 'form.no' })}
          </Button>
        )}
        {!!okHandler && (
          <Button classes={{ root: classes.button }} variant="contained" onClick={okHandler} color="primary">
            {formatMessage({ id: 'form.ok' })}
          </Button>
        )}
        {!!cancelHandler && (
          <Button classes={{ root: classes.button }} variant="outlined" onClick={cancelHandler} color="primary">
            {formatMessage({ id: 'form.cancel' })}
          </Button>
        )}
      </DialogActions>
    </MuiDialog>
  );
}
